import { DebriefEventDTO } from '../interface/debrief/debrief-interface'

export const createDebriefEvent = (description: string): DebriefEventDTO => {
	return {
		description,
		isMatchPoint: true,
	}
}
